import { useState } from "react";
import InfoBox from "./info-box/InfoBox";
import KeycloakService from "../../../../config/keycloak";
import { AccountCircle, Domain } from "@mui/icons-material";
import ClickableDropdown from "../../../ui/dropdowns/clickable-dropdown/ClickableDropdown";
import { useSelector } from "react-redux";

const ToolbarInfoBoxes = (props) => {
  const selectedCustomerName = useSelector(
    (state) => state.customersReducer.selectedCustomer.name
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const profileMenuItems = [
    {
      text: "Logout",
      disabled: false,
      icon: null,
      handleClick: () => {
        KeycloakService.doLogout();
      },
    },
  ];

  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const iconStyle = {
    color: "black",
    marginRight: "0.5em",
  };

  return (
    <>
      <InfoBox
        label={selectedCustomerName}
        icon={<Domain sx={iconStyle} />}
        onClick={props.handleSetDialogOpen}
      />
      <InfoBox
        label={KeycloakService.getUsername() ?? ""}
        icon={<AccountCircle sx={iconStyle} />}
        onClick={handleDropdownOpen}
      />
      <ClickableDropdown
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        menuItems={profileMenuItems}
      />
    </>
  );
};

export default ToolbarInfoBoxes;
